import { FieldHtmlNameUtil } from '@onshape/www-inertia';
import UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import AbstractSignupScreen from './AbstractSignupScreen';
import UnifiedSignupIntent from '../session-info/UnifiedSignupIntent';
import type { UnifiedSignupScreenName } from '../UnifiedSignupScreenName';
import UnifiedSignupStartScreen from '../session-info/UnifiedSignupStartScreen';

export default class IntentSignupScreen extends AbstractSignupScreen {
  public readonly screenName: UnifiedSignupScreenName = 'uss-intent';

  public getVisibleComponents(): UnifiedSignupScreenComponent[] {
    return [];
  }

  public getValidatedComponents(): UnifiedSignupScreenComponent[] {
    return [
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.whatIsYourIntent),
      }),
    ];
  }

  /** Show this screen if we have checked email but don't know the users intent.
   *  In case of homepage signup screen also check if firstName is not null.
   */
  public predicate(): boolean {
    const { intent } = this.sessionInfo.value;
    const { startScreen } = this.sessionInfo.value;
    const { firstName } = this.sessionInfo.value;
    if (UnifiedSignupStartScreen.homepageSignup.compareTo(startScreen)) {
      return intent === null && this.isOkEmailOrPro() && firstName !== null;
    }
    return intent === null && this.isOkEmailOrPro();
  }

  public async toNextScreen(): Promise<boolean> {
    const intent = this.getField(FieldHtmlNameUtil.whatIsYourIntent).val;
    this.sessionInfo.value.intent = UnifiedSignupIntent.fromString(intent);
    return true;
  }

  public getProgress(): number {
    return 20;
  }
}
